<template>
  <div class="home">
    <ul>
      <li v-for='region in RegionNames' :key='region'>
        <strong>{{region}}</strong>
        <ul>
          <li v-for='version in Regions[region]' :key='version'>
            <router-link :to='`${region}/${version}`'>{{version}}</router-link>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
// @ is an alias to /src
import API from '../API'

export default {
  name: 'home',
  data: () => ({ Regions: {} }),

  computed: {
    RegionNames() {
      return Object.keys(this.Regions)
    }
  },

  created() { this.FetchData() },
  watch: { '$route': 'FetchData' },
  methods: {
    FetchData() {
      API.WZ('').then(versions => {
        let grouped = versions.reduceRight((total, current) => {
          let region = total[current.region]
          if (!region) total[current.region] = [ current.mapleVersionId ]
          else region.push(current.mapleVersionId)

          return total
        }, {})

        this.Regions = grouped
      })
    }
  }
}
</script>

<style scoped>
.home {
  overflow: auto;
  max-height: 100%;
}

li li {
  display: inline-block;
  padding: 4px;
  margin: 4px;
  box-shadow: 0 0 2px black;
}
</style>